'use strict';

import {
    addFormControlSelect2,
    fnErrorMsg, fnToastrFormError,
    getSelectedRowData, printResponse, setMissingVoucherText, setSelect,
    subLangPlaceHolder
} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnMarkSelectedVouchersAsMissing = function () {

    var tableName = '#datatable-vouchers';

    if (!element_exists(tableName)) return false;

    var lang = allLangFiles.vouchers;

    var btnMarkAsMissing = $('#btn-mark-selected-vouchers-as-missing');

    btnMarkAsMissing.off('click').on('click', function (e) {

        $(this).parent().parent('.dropdown.open').removeClass('open');

        var dataTable = $(tableName).DataTable();
        var selectedRowData = getSelectedRowData(dataTable);

        var data = [];

        var texts = [];
        var invalidSelections = [];

        $.each(selectedRowData, function (index, voucher) {

            console.log(voucher);
            if (voucher.valid_for_marking_as_missing) {
                data.push(voucher.id);
                texts.push('#' + voucher.VoucherNumber);
            }
            /*reset and return if any selections have been uploaded*/
            else {
                invalidSelections.push('#' + voucher.VoucherNumber);
            }
        });


        if (invalidSelections.length) {
            toastr.warning(
                subLangPlaceHolder(lang.select.mark_as_missing_confirm.invalid, ':body', '<br>' + invalidSelections.join(',') + '<br>')
            );
            data = [];
            return false;
        }

        if (data.length) {
            $.ajax({
                method: 'GET',
                url: '/voucher/approved-accounts/' + selectedRowData[0].company_id,
                success: function (response) {

                    var accounts = response.collectionEconomicAccounts;

                    var content = subLangPlaceHolder(lang.select.mark_as_missing_confirm.content + ' ' + lang.select.mark_as_missing_confirm.description, ':body', '<br>' + texts.join(',') + '<br>');
                    /*Need to load accounts...*/
                    var accountLabel = '<br><br>    <label for="missing_account" value="">' + lang.account_handle + '</label>';
                    var accountElement = '<select class="form-control" required="required" id="missing_account" name="missing_account" tabindex="-1" aria-hidden="true"></select>'
                    var commentLabel = '<br><label for="missing_comment" value="">' + lang.comment + '</label>';
                    var comment = '<textarea class="form-control" id="missing_comment" name="missing_comment" cols="50" rows="10" style="background: #fff"></textarea>';

                    content += accountLabel + accountElement + '<br><br>' + commentLabel + comment;


                    $.confirm({
                        onOpen: function () {
                            let $missingAccounts = this.$content.find('#missing_account');

                            setSelect(accounts, $missingAccounts, 'accountNumber', ['accountNumber', 'name'], lang.js.account_select);

                            $missingAccounts.select2({
                                placeholder: lang.account_select,
                                width: '100%',
                                height: '75%',
                                dropdownParent: $(".jconfirm-default")
                            }).addClass('form-control');
                            addFormControlSelect2();
                        },
                        title: lang.select.mark_as_missing_confirm.title,
                        content: content,
                        theme: 'supervan',
                        columnClass: 'col-md-12',
                        backgroundDismiss: true,
                        buttons: {
                            Ja: {
                                action: function () {
                                    let accountVal = $('#missing_account').val();
                                    let commentVal = $('#missing_comment').val();
                                    if (!accountVal || !commentVal) {
                                        toastr.error('Missing account or comment');
                                        return false;
                                    }
                                    $.ajax({
                                        type: 'POST',
                                        url: '/voucher/mark-as-missing/selection',
                                        data: {
                                            ids: data,
                                            account: accountVal,
                                            comment: commentVal,
                                        },
                                        success: function (response) {
                                            printResponse(response);
                                            dataTable.ajax.reload(function () {
                                                setMissingVoucherText();
                                            }, false);
                                        },
                                        error: fnToastrFormError
                                    });
                                },
                                text: lang.yes
                            },
                            Nej: {
                                text: lang.no
                            },
                        }
                    });
                },
                error: fnErrorMsg
            });
        }
    });
};